<template>
  <div class="imgBox min-w-1400">
    <!-- <div class="imgBox1 min-w-1400" @click="toggleNewImage(1)">
      <div class="img1 max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div> -->
    <section id="stats_z53n4" class="stats-section position-relative py-5 overflow-hidden" style="min-height: 500px;">
        <div class="bg-carousel" aria-hidden="true">
          <div
            v-for="(bgImage, index) in bgImages"
            :key="bgImage"
            class="bg-slide"
            :class="{ active: currentBgIndex === index }"
            :style="{ backgroundImage: `url(${bgImage})` }"
          ></div>
        </div>
        
        
        <!-- Gradient Overlay -->
        <div class="position-absolute top-0 start-0 w-100 h-100" style="background: linear-gradient(to bottom, rgba(15, 23, 42, 0.45) 0%, rgba(15, 23, 42, 0.75) 100%); z-index: 1;"></div>
        
        <div class="container position-relative py-5" style="z-index: 2;">
          <!-- Header Section -->
          <div class="row justify-content-center mb-5 pb-4">
            <div class="col-lg-8 text-center">
               <h2 class="display-5 fw-bold text-white mb-4">Tiêu đề: Minh chứng niềm tin bằng những con số ấn tượng</h2>
               <!-- <p class="lead text-white-50 mx-auto" style="max-width: 600px; line-height: 1.8;"></p> -->
               <div class="mt-4 mx-auto" style="width: 60px; height: 4px; background: #3b82f6; border-radius: 2px;"></div>
            </div>
          </div>

          <!-- Stats Grid -->
          <div class="row text-center mt-4">
            
      <div class="col-md-3 mb-5 mb-md-0">
        <div class="stat-item position-relative">
          <div class="display-3 fw-bold mb-2 text-white" style="font-family: 'Segoe UI', sans-serif; letter-spacing: -2px;">
          <span class="counter-anim " data-target="300000">300.000</span><span>+</span></div>
          <div class="text-white-50 text-uppercase small tracking-wider fw-bold border-top border-secondary pt-3 d-inline-block" style="letter-spacing: 2px;">
              Người dùng tin dùng
          </div>
        </div>
      </div>
    
      <div class="col-md-3 mb-5 mb-md-0">
        <div class="stat-item position-relative">
          <div class="display-3 fw-bold mb-2 text-white" style="font-family: 'Segoe UI', sans-serif; letter-spacing: -2px;">
          <span class="counter-anim " data-target="200">200</span><span></span></div>
          <div class="text-white-50 text-uppercase small tracking-wider fw-bold border-top border-secondary pt-3 d-inline-block" style="letter-spacing: 2px;">
              Chuyên gia tài chính
          </div>
        </div>
      </div>
    
      <div class="col-md-3 mb-5 mb-md-0">
        <div class="stat-item position-relative">
          <div class="display-3 fw-bold mb-2 text-white" style="font-family: 'Segoe UI', sans-serif; letter-spacing: -2px;">
          <span class="counter-anim " data-target="4.23">4.42</span><span>M+</span></div>
          <div class="text-white-50 text-uppercase small tracking-wider fw-bold border-top border-secondary pt-3 d-inline-block" style="letter-spacing: 2px;">
             Lượt xem sản phẩm
          </div>
        </div>
      </div>
    
      <div class="col-md-3 mb-5 mb-md-0">
        <div class="stat-item position-relative">
          <div class="display-3 fw-bold mb-2 text-white" style="font-family: 'Segoe UI', sans-serif; letter-spacing: -2px;">
          <span class="counter-anim " data-target="5.67">5.67</span><span>M+</span></div>
          <div class="text-white-50 text-uppercase small tracking-wider fw-bold border-top border-secondary pt-3 d-inline-block" style="letter-spacing: 2px;">
              Lượt hiển thị thương hiệu
          </div>
        </div>
      </div>
    
          </div>
        </div>
    </section>

    <div class="container py-5">
        <div class="text-center mb-5">
            <h2 class="h2-text fw-bold display-6 mb-2 text-dark">Quá trình phát triển</h2>
            <p class="text-muted fs-5 text-p">Hành trình vươn tầm của đội ngũ Lavi Finance</p>
            <div class="mx-auto mt-4 rounded-pill" style="width: 50px; height: 4px; background-color: #3b82f6;"></div>
        </div>

        <div class="timeline-container position-relative py-2">
            <!-- Vertical Line -->
            <div class="timeline-line"></div>
            
            
        <div class="timeline-item left active">
            <div class="timeline-content shadow-sm p-4 rounded-4 bg-white border border-light position-relative">
                <span class="date-badge position-absolute top-0 start-0 translate-middle badge rounded-pill px-3 py-2 shadow-sm"
                      style="background: #3b82f6; color: #fff; border: 4px solid white;">
                    Tháng09/2024
                </span>
                <h5 class="fw-bold mt-2 mb-2" style="color: #3b82f6"></h5>
                <p class="text-muted mb-0 small" style="line-height: 1.6;">Đặt những viên gạch đầu tiên Đội ngũ Lavi Finance chính thức được thành lập với hơn 200 nhân sự tâm huyết. Chúng tôi bắt đầu hành trình với một khát khao duy nhất: Định nghĩa lại trải nghiệm tài chính số tại Việt Nam.</p>
            </div>
            <div class="timeline-dot"></div>
        </div>
        
        <div class="timeline-item right ">
            <div class="timeline-content shadow-sm p-4 rounded-4 bg-white border border-light position-relative">
                <span class="date-badge position-absolute top-0 start-0 translate-middle badge rounded-pill px-3 py-2 shadow-sm"
                      style="background: #f1f5f9; color: #64748b; border: 4px solid white;">
                    Tháng 04/2025
                </span>
                <h5 class="fw-bold mt-2 mb-2" style="color: #1e293b"></h5>
                <p class="text-muted mb-0 small" style="line-height: 1.6;">Chào sân ấn tượng Ứng dụng Lavi Finance chính thức có mặt trên các cửa hàng ứng dụng. Đây là cột mốc đánh dấu sự ra đời của một "người bạn đồng hành tài chính thông minh" dành cho mọi người dân Việt Nam.</p>
            </div>
            <div class="timeline-dot"></div>
        </div>
        
        <div class="timeline-item left ">
            <div class="timeline-content shadow-sm p-4 rounded-4 bg-white border border-light position-relative">
                <span class="date-badge position-absolute top-0 start-0 translate-middle badge rounded-pill px-3 py-2 shadow-sm"
                      style="background: #f1f5f9; color: #64748b; border: 4px solid white;">
                    Tương lai
                </span>
                <h5 class="fw-bold mt-2 mb-2" style="color: #1e293b"></h5>
                <p class="text-muted mb-0 small" style="line-height: 1.6;">Vươn mình ra thế giới Dưới sự dẫn dắt chiến lược từ hệ thống Ngân hàng uy tín, Lavi Finance không dừng lại ở thị trường trong nước. Chúng tôi đang không ngừng tối ưu hóa trải nghiệm để mở rộng quy mô, hướng tới mục tiêu mang giải pháp tài chính Việt vươn tầm thế giới.</p>
                <br>
                <p class="text-muted mb-0 small" style="line-height: 1.6;">Năm đầu tiên: Sự bùng nổ của niềm tin Chỉ trong vòng 1 năm, chúng tôi tự hào đã đạt được những con số biết nói: <br> <br>
                    - 5.67 triệu lượt hiển thị: Thương hiệu Lavi Finance lan tỏa mạnh mẽ.<br> <br>
                    - 4.42 triệu lượt truy cập: Sự quan tâm không ngừng từ thị trường.<br> <br>
                    - 145.000 lượt tải mới & 126.000 lượt tải lại: Minh chứng cho sự gắn bó và hài lòng tuyệt đối của khách hàng.</p>
            </div>
            <div class="timeline-dot"></div>
        </div>
        
        </div>
      </div>
<!-- =============================== -->
      <div class="cart">
        <section class="cash-loan max-w-1400 fade-in-section">
          <div class="cash-loan__header">
            <h2 class="h2-text cash-loan__title">Văn hóa Lavi</h2>
            <p class="text-p">
              Ghi nhớ DNA Lavi, Sâu sắc DNA Sáng tạo, Lan tỏa DNA đến mọi người
            </p>
            
          </div>

          <div class="cash-loan__grid">
            <article class="cash-loan-card">
              <div class="cash-loan-card__copy">
                <h3 class="cash-loan-card__title">Gắn kết như gia đình</h3>
                <p class="cash-loan-card__text">Nơi mỗi thành viên được lắng nghe, thấu hiểu và trân trọng.</p>
              </div>
              <div class="cash-loan-card__visual cash-loan-card__visual--simple">
                <img :src="iconImg1" alt="iconImg1" class="cash-loan-card__icon">
              </div>
            </article>

            <article class="cash-loan-card">
              <div class="cash-loan-card__copy">
                <h3 class="cash-loan-card__title">Sáng tạo bằng trái tim</h3>
                <p class="cash-loan-card__text">Thấu hiểu người dùng để tạo nên trải nghiệm tài chính nhân văn.</p>
              </div>
              <div class="cash-loan-card__visual cash-loan-card__visual--limit">
                <img :src="iconImg2" alt="iconImg2" class="cash-loan-card__icon">
              </div>
            </article>

            <article class="cash-loan-card">
              <div class="cash-loan-card__copy">
                <h3 class="cash-loan-card__title"> Trao gửi trọn niềm tin</h3>
                <p class="cash-loan-card__text">Vững vàng nền tảng VIB AMC, cùng khách hàng chạm đến ước mơ.</p>
              </div>
              <div class="cash-loan-card__visual cash-loan-card__visual--clear">
                <img :src="iconImg3" alt="iconImg3" class="cash-loan-card__icon">
              </div>
            </article>

            <article class="cash-loan-card">
              <div class="cash-loan-card__copy">
                <h3 class="cash-loan-card__title">Kiến tạo tương lai hạnh phúc</h3>
                <p class="cash-loan-card__text">Mang khát vọng toàn cầu đi cùng lời hứa về sự an tâm.</p>
              </div>
              <div class="cash-loan-card__visual cash-loan-card__visual--rate">
                <img :src="iconImg4" alt="iconImg4" class="cash-loan-card__icon">
              </div>
            </article>
          </div>
        </section>
      </div>
      <!-- =============================== -->
  </div>
</template>

<script>
import "./index.css";

import importedImg2 from "@/page/lavifinancecompany/components/img/3_1.png";
import importedImg3 from "@/page/lavifinancecompany/components/img/3_3.png";
import importedImg4 from "@/page/lavifinancecompany/components/img/3_4.png";
import importedImg5 from "@/page/lavifinancecompany/components/img/3_5.png";
import importedImg6 from "@/page/lavifinancecompany/components/img/3_6.png";
import importedImg7 from "@/page/lavifinancecompany/components/img/3_7.png";
import importedImg8 from "@/page/lavifinancecompany/components/img/3_8.png";
import importedImg9 from "@/page/lavifinancecompany/components/img/3_9.png";
import importedImg10 from "@/page/lavifinancecompany/components/img/3_10.png";
import importedImg11 from "@/page/lavifinancecompany/components/img/3_11.png";
import importedImg12 from "@/page/lavifinancecompany/components/img/3_12.png";
import importedImg13 from "@/page/lavifinancecompany/components/img/3_13.png";
import importedImg14 from "@/page/lavifinancecompany/components/img/3_14.png";
// import importedImg15 from "@/page/lavifinancecompany/components/img/3_15.png";

import AnswerImg3 from "@/page/lavifinancecompany/components/img/3_3_3.png";
import AnswerImg4 from "@/page/lavifinancecompany/components/img/3_4_4.png";
import AnswerImg5 from "@/page/lavifinancecompany/components/img/3_5_5.png";
import AnswerImg6 from "@/page/lavifinancecompany/components/img/3_6_6.png";
import AnswerImg7 from "@/page/lavifinancecompany/components/img/3_7_7.png";
import AnswerImg8 from "@/page/lavifinancecompany/components/img/3_8_8.png";
import AnswerImg9 from "@/page/lavifinancecompany/components/img/3_9_9.png";
import AnswerImg10 from "@/page/lavifinancecompany/components/img/3_10_10.png";
import AnswerImg11 from "@/page/lavifinancecompany/components/img/3_11_11.png";
import AnswerImg12 from "@/page/lavifinancecompany/components/img/3_12_12.png";
import AnswerImg13 from "@/page/lavifinancecompany/components/img/3_13_13.png";
import AnswerImg14 from "@/page/lavifinancecompany/components/img/3_14_14.png";
import bgImg1 from "@/page/lavifinancecompany/components/img/bg.jpg";
import bgImg2 from "@/page/lavifinancecompany/components/img/bg-2.jpg";
import bgImg3 from "@/page/lavifinancecompany/components/img/bg-4.jpg";


import iconImg1 from "@/page/lavifinancecompany/components/img/iocn-1.png";
import iconImg2 from "@/page/lavifinancecompany/components/img/iocn-2.png";
import iconImg3 from "@/page/lavifinancecompany/components/img/iocn-3.png";
import iconImg4 from "@/page/lavifinancecompany/components/img/iocn-4.png";

// import AnswerImg15 from "@/page/lavifinancecompany/components/img/3_15_15.png";
export default {
  data() {
    return {
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      importedImg6: importedImg6,
      importedImg7: importedImg7,
      importedImg8: importedImg8,
      importedImg9: importedImg9,
      importedImg10: importedImg10,
      importedImg11: importedImg11,
      importedImg12: importedImg12,
      importedImg13: importedImg13,
      importedImg14: importedImg14,
      // importedImg15: importedImg15,
      AnswerImg3: AnswerImg3,
      AnswerImg4: AnswerImg4,
      AnswerImg5: AnswerImg5,
      AnswerImg6: AnswerImg6,
      AnswerImg7: AnswerImg7,
      AnswerImg8: AnswerImg8,
      AnswerImg9: AnswerImg9,
      AnswerImg10: AnswerImg10,
      AnswerImg11: AnswerImg11,
      AnswerImg12: AnswerImg12,
      AnswerImg13: AnswerImg13,
      AnswerImg14: AnswerImg14,
      bgImg1: bgImg1,
      bgImg2: bgImg2,
      bgImg3: bgImg3,
      iconImg1: iconImg1,
      iconImg2: iconImg2,
      iconImg3: iconImg3,
      iconImg4: iconImg4,
      // AnswerImg15: AnswerImg15,

      altText: "图片",
      showNewImage2: false,
      showNewImage3: false,
      showNewImage4: false,
      showNewImage5: false,
      showNewImage6: false,
      showNewImage7: false,
      showNewImage8: false,
      showNewImage9: false,
      showNewImage10: false,
      showNewImage11: false,
      showNewImage12: false,
      showNewImage13: false,
      showNewImage14: false,
      showNewImage15: false,
      activeImage: 0,
      bgImages: [bgImg1, bgImg2, bgImg3],
      currentBgIndex: 0,
      bgCarouselTimer: null,
    };
  },
  mounted() {
    this.InitPage();
    this.startBgCarousel();
  },
  beforeDestroy() {
    this.stopBgCarousel();
  },
  methods: {
    startBgCarousel() {
      if (this.bgImages.length <= 1) {
        return;
      }
      this.stopBgCarousel();
      this.bgCarouselTimer = window.setInterval(() => {
        this.currentBgIndex = (this.currentBgIndex + 1) % this.bgImages.length;
      }, 4000);
    },
    stopBgCarousel() {
      if (this.bgCarouselTimer) {
        window.clearInterval(this.bgCarouselTimer);
        this.bgCarouselTimer = null;
      }
    },
    toggleNewImage(imageIndex) {
      //  console.log("点击了");
      //   this.$set(this.showNewImage, imageIndex, !this.showNewImage[imageIndex]);
      //   this.activeImage = imageIndex;
      console.log(this.showNewImage3);
      if (imageIndex == 2) {
        this.showNewImage2 = !this.showNewImage2;
      }
      if (imageIndex == 3) {
        this.showNewImage3 = !this.showNewImage3;
      }
      if (imageIndex == 4) {
        this.showNewImage4 = !this.showNewImage4;
      }
      if (imageIndex == 5) {
        this.showNewImage5 = !this.showNewImage5;
      }
      if (imageIndex == 6) {
        this.showNewImage6 = !this.showNewImage6;
      }
      if (imageIndex == 7) {
        this.showNewImage7 = !this.showNewImage7;
      }
      if (imageIndex == 8) {
        this.showNewImage8 = !this.showNewImage8;
      }
      if (imageIndex == 9) {
        this.showNewImage9 = !this.showNewImage9;
      }
      if (imageIndex == 10) {
        this.showNewImage10 = !this.showNewImage10;
      }
      if (imageIndex == 11) {
        this.showNewImage11 = !this.showNewImage11;
      }
      if (imageIndex == 12) {
        this.showNewImage12 = !this.showNewImage12;
      }
      if (imageIndex == 13) {
        this.showNewImage13 = !this.showNewImage13;
      }
      if (imageIndex == 14) {
        this.showNewImage14 = !this.showNewImage14;
      }
      if (imageIndex == 15) {
        this.showNewImage15 = !this.showNewImage15;
      }
    },
    InitPage(){
      window.scrollTo({ top: 0 });
      const fadeInSections = document.querySelectorAll('.fade-in-section');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
      });
    }, {
        threshold: 0.3
    });
      fadeInSections.forEach(section => {
          observer.observe(section);
      });
    }
  },
};
</script>


<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7,
.imgBox8,
.imgBox9,
.imgBox10,
.imgBox11,
.imgBox12,
.imgBox13,
.imgBox14,
.imgBox15 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #FAFAFA;
}

img {
  display: block;
}
.img2,
.img3,
.img4,
.img5,
.img6,
.img7,
.img8,
.img9,
.img10,
.img11,
.img12,
.img13,
.img14,
.img15 {
  width: 100%;
  overflow: hidden;
  justify-content: space-between;
  margin: 0;
}

.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7,
.imgItem8,
.imgItem9,
.imgItem10,
.imgItem11,
.imgItem12,
.imgItem13,
.imgItem14,
.imgItem15 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7,
.imgItem8,
.imgItem9,
.imgItem10,
.imgItem11,
.imgItem12,
.imgItem13,
.imgItem14,
.imgItem15 {
  /* margin-top: 10px; */
  transform: scale(80%);
}
.img14 {
  margin-bottom: 300px;
}
.img3{
  margin-top: 70px;
}
.stats-section {
  isolation: isolate;
}

.bg-carousel {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.bg-slide {
  position: absolute;
  inset: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.bg-slide.active {
  opacity: 1;
}

.cart {
  display: flex;
  justify-content: center;
  padding: 28px 0 84px;
}

.cash-loan {
  width: 100%;
}

.cash-loan__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 42px;
}

.cash-loan__title {
  margin: 0;
  color: #050505;
  font-weight: 800;
  line-height: 1.1;
}

.h2-text{
  font-size: 40px;
}

.cash-loan__subtitle {
  margin: 18px 0 0;
  color: #b8b8b8;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.5;
}

.cash-loan__action {
  margin-top: 28px;
  padding: 16px 30px;
  border: none;
  border-radius: 999px;
  background: #000000;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.cash-loan__action:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 28px rgba(0, 0, 0, 0.16);
}

.cash-loan__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 28px 32px;
}

.cash-loan-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px;
  align-items: center;
  min-height: 220px;
  padding: 30px 38px;
  background: linear-gradient(180deg, #fafafa 0%, #f7f7f7 100%);
  border-radius: 34px;
  overflow: hidden;
}

.cash-loan-card__copy {
  padding-right: 18px;
}

.cash-loan-card__title {
  margin: 0 0 16px;
  color: #050505;
  font-size: 38px;
  font-weight: 800;
  line-height: 1.1;
}

.cash-loan-card__text {
  margin: 0;
  color: #b7b7b7;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.45;
}

.cash-loan-card__visual {
  position: relative;
  height: 150px;
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.62);
}

.cash-loan-card__visual--simple {
  background: linear-gradient(180deg, rgba(255, 243, 237, 0.95) 0%, rgba(255, 248, 245, 0.9) 100%);
}

.cash-loan-card__visual--limit {
  background: linear-gradient(180deg, rgba(246, 247, 250, 0.96) 0%, rgba(250, 250, 250, 0.92) 100%);
}

.cash-loan-card__visual--clear {
  background: linear-gradient(180deg, rgba(244, 248, 252, 0.96) 0%, rgba(248, 250, 252, 0.92) 100%);
}

.cash-loan-card__visual--rate {
  background: linear-gradient(180deg, rgba(255, 250, 237, 0.96) 0%, rgba(252, 249, 242, 0.92) 100%);
}
.timeline-container {
            max-width: 1000px;
            margin: 0 auto;
        }

        /* Central Line */
        .timeline-line {
            position: absolute;
            left: 50%;
            top: 0;
            bottom: 0;
            width: 2px;
            background: #e2e8f0;
            transform: translateX(-50%);
            z-index: 1;
        }

        .timeline-item {
            position: relative;
            margin-bottom: 3rem;
            width: 100%;
            z-index: 2;
        }

        /* Content Boxes */
        .timeline-content {
            width: 45%;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .timeline-content:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 30px rgba(0,0,0,0.08) !important;
        }

        /* Dot on the line */
        .timeline-dot {
            position: absolute;
            left: 50%;
            top: 25px; /* Aligns with content top roughly */
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: white;
            border: 3px solid #cbd5e1;
            transform: translateX(-50%);
            z-index: 3;
            transition: all 0.3s ease;
        }

        /* Left vs Right Positioning */
        .timeline-item.left .timeline-content {
            margin-left: 0;
            margin-right: auto;
        }
        
        .timeline-item.right .timeline-content {
            margin-left: auto;
            margin-right: 0;
        }
        
        /* Arrows */
        .timeline-item.left .timeline-content::after {
            content: " ";
            position: absolute;
            top: 28px;
            right: -10px;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            border-left: 10px solid white;
        }

        .timeline-item.right .timeline-content::after {
            content: " ";
            position: absolute;
            top: 28px;
            left: -10px;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            border-right: 10px solid white;
        }

        /* Active State */
        .timeline-item.active .timeline-dot {
            background: #3b82f6;
            border-color: white;
            box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.2);
            transform: translateX(-50%) scale(1.2);
            animation: pulse 2s infinite;
        }
        
        .timeline-item.active .timeline-content {
            border-color: rgba(59, 130, 246, 0.3) !important;
            box-shadow: 0 10px 25px rgba(59, 130, 246, 0.1) !important;
        }

        @keyframes pulse {
            0% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4); }
            70% { box-shadow: 0 0 0 10px rgba(59, 130, 246, 0); }
            100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0); }
        }

        /* Mobile Responsiveness */
        @media (max-width: 767px) {
            .cash-loan__title {
                font-size: 42px;
            }

            .cash-loan__subtitle {
                font-size: 18px;
            }

            .cash-loan__grid {
                grid-template-columns: 1fr;
                gap: 20px;
            }

            .cash-loan-card {
                grid-template-columns: 1fr;
                gap: 18px;
                min-height: 0;
                padding: 26px 24px;
            }

            .cash-loan-card__copy {
                padding-right: 0;
            }

            .cash-loan-card__title {
                font-size: 30px;
            }

            .cash-loan-card__text {
                font-size: 18px;
            }

            .cash-loan-card__visual {
                height: 132px;
            }

            .timeline-line {
                left: 20px;
            }
            
            .timeline-content {
                width: calc(100% - 60px);
                margin-left: 60px !important;
            }
            
            .timeline-dot {
                left: 20px;
            }
            
            .timeline-item.left .timeline-content::after,
            .timeline-item.right .timeline-content::after {
                left: -10px;
                right: auto;
                border-left: none;
                border-right: 10px solid white;
            }
            
            .date-badge {
                left: 0 !important;
                transform: translate(0, -50%) !important;
            }
        }

        .text-p{
          font-size: 20px;
          color: var(--bs-secondary-color);
        }
</style>
